// Business Companies Listing Apis
global.adminAddBusinessUser = global.API_ADMIN_URL+'adminAddBusinessUser/';
global.adminEditBusinessUser = global.API_ADMIN_URL+'adminEditBusinessUser/';
global.adminBusinessUserList = global.API_ADMIN_URL+'adminBusinessUserList/';
global.adminBusinessUserDelete = global.API_ADMIN_URL+'adminBusinessUserDelete/';
global.adminBusinessUserStatus = global.API_ADMIN_URL+'adminBusinessUserStatus/';
global.adminBusinessUserDetails = global.API_ADMIN_URL+'adminBusinessUserDetails/';

// For business dashbaord
global._business_BusinessUserList = global.API_BUSINESS_URL+'businessUserList/';